import { PublicClientApplication, type Configuration } from "@azure/msal-browser";
import type { RuntimeConfig } from "../runtime-config";

export function buildMsalInstance(cfg: RuntimeConfig): PublicClientApplication {
  const config: Configuration = {
    auth: {
      clientId: cfg.spaClientId,
      authority: `https://login.microsoftonline.com/${cfg.tenantId}`,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  };
  return new PublicClientApplication(config);
}

export const apiScopeRequest = (scope: string) => ({ scopes: [scope] });
